import { Component,ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MenuService,NavigrationParentItem, NavigationCollection } from './../../services/index';
import 'rxjs/add/operator/filter';
import { ApiService } from '../../services/api.service';
import { DynamicPage,User } from '../../models/data.types' 
import { AppSidebarNavComponent } from '../app-sidebar-nav'
import { isNoSubstitutionTemplateLiteral } from 'typescript';


@Component({
  selector: 'app-breadcrumbs-child-menus',
  providers: [MenuService],  
  template: `
            <ul>
                <ng-container  *ngFor="let item of (navigationCollection | async)?.allUrls" >
                <li *ngFor="let link of item.children">
                <app-sidebar-nav-link   [link]='link'></app-sidebar-nav-link>                   
                </li>
                </ng-container >
            </ul>
            `
})
export class AppBreadcrumbsChildMenusComponent  {
    @Input() item: any;

    private navigationCollection : Promise<NavigationCollection>;
    private user: User;

    constructor(private navSvc:MenuService
              ) {}
    ngOnInit() {        
        this.user = JSON.parse(localStorage.getItem('currentUser'));      
       // this.navigationCollection =  this.navSvc.GetSubMenus(this.user.ProfileId, this.item.label); 
    }
    
}

@Component({
  selector: 'app-breadcrumbs', 
  providers: [AppSidebarNavComponent],
  template:  `
  
    
  <ol style="margin: 0" class="breadcrumb" *ngIf="breadcrumbs.length > 0"> 
  <!--
  <label class="switch switch-3d switch-warning switch-text switch-info float-right mb-0" style="margin-right:6px" >
      <input type="checkbox"  [attr.checked]="showFavOnly   ? 'checked' : null" class="switch-input" (change)="toggleFavorite();">
      <span class="switch-label" data-on="Fav Only" data-off="All"></span>
      <span class="switch-handle"></span>
    </label>
  -->
  <li class="breadcrumb-item">
      <a routerLink="/Dashboard/Scheid/Portals/SystemDashboardPage">Home</a>      
    </li>
  <ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs" let-last = last>
    <li class="breadcrumb-item"       
        [ngClass]="{active: last}">
      <span *ngIf="!last">{{breadcrumb.label}}</span>
      <span *ngIf="last">{{breadcrumb.label}}</span>      
      <app-breadcrumbs-child-menus [item]='breadcrumb'></app-breadcrumbs-child-menus>      
    </li>
 </ng-template>
 <div style="padding-left:4px;padding-top:0">
 
  <!--
  <a><i class="fa fa-star text-warning"></i></a>
  <label  class="switch switch-sm switch-text switch-info float-right mb-0">
      <input type="checkbox"  [attr.checked]="isfavorite  ? 'checked' : null" (change)="do('CW-PortalMenuToggleFavorite', {menuid: menuid, username : username});" class="switch-input">
      <span class="switch-label" data-onstyle="start" data-on="On" data-off="Off"></span>
      <span class="switch-handle"></span>
  </label>
  -->
 </div>
 <a *ngIf="mainPageId && user.isDeveloper" href="/#/Dashboard/Scheid/Admin/edit-page?pageId={{mainPageId}}"><span style="padding-left:8px; color: #666;padding-top:2px"><i class="fa fa-edit"></i></span></a>
  </ol>
  `
})
//item.ISFAVORITE ? 'checked' : null" class="switch-input" type="checkbox" (change)="do('SCHEID_NAV_TOGGLEFAV', {username: user.username, profilemenuid: item.PROFILEMENUID});
// <div class="btn-group" dropdown>
// <button type="button" class="btn btn-sm btn-secondary">Action</button>
// <button type="button" dropdownToggle class="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split">
//   <span class="caret"></span>
//   <span class="sr-only">Page Title</span>
// </button>
// <ul *dropdownMenu class="dropdown-menu" role="menu">
//   <li *ngFor="let parent of navigation" role="menuitem">
//     <a class="dropdown-item">{{parent.name}}</a>
//   </li>
// </ul>
// </div>
export class AppBreadcrumbsComponent  {
  breadcrumbs: Array<Object>;
  mainPageId : string;
  public navigation: NavigrationParentItem[] = [];
  menuparent: any[] = [];
  user: User;
  isPortal : boolean = false;
  portalId : string = "";
  isfavorite : boolean = false;
  showFavOnly : boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private sideBar : AppSidebarNavComponent
  ) {
    
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event) => {
      this.breadcrumbs = [];
      let pageRouteNames : {} = {};
      let currentRoute = this.route.root,
      url = '';
      this.user = JSON.parse(localStorage.getItem('currentUser'));

      if(localStorage.getItem('showFavOnly') != null)
      {
        this.showFavOnly =  JSON.parse(localStorage.getItem('showFavOnly'));
      }
      else
      {
        this.showFavOnly =  false;
      }
      

      do {
        const childrenRoutes = currentRoute.children;
        let labeldata : string;
        currentRoute = null;
        // tslint:disable-next-line:no-shadowed-variable

        childrenRoutes.forEach(route => {
          if (route.outlet === 'primary') {
            const routeSnapshot = route.snapshot;
            url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');

           labeldata= routeSnapshot.url[routeSnapshot.url.length-1].path;

            if (labeldata == "Dashboard")
            {
              this.breadcrumbs= [];
            }
            else if(labeldata != "Scheid")
            {
              if(routeSnapshot.params["id"] != null)
              {
                let username :string;
  
              if(this.user != null)
              {
                username = this.user.username;
              }
              else
              {
                username ="";
              }

              let body = JSON.parse('{"route": "'+labeldata+'","portalId":"'+this.portalId+'","email":"'+username+'"}');

                this.apiService.postAs<any>('data/doquery/GetPageInfoByRoute/',body).then(response => {

                  let pageName : string;

                  pageName = response.Item.name;
                  
                  this.isfavorite = response.Item.isfavorite;
                  
                  this.breadcrumbs.push({
                    label: pageName ,
                    url:   url
                  });

                  if(response.Item.id != "0"){
                      this.mainPageId = response.Item.id

                      this.apiService.get<string[]>('account/getroles')
                                                .then(roles => {
                                                  this.apiService.roles = roles;
                                                });
                  }
                
                }).catch(e => {
                 console.log(e)
                });
              }
              else
              {
                this.breadcrumbs.push({
                  label: labeldata ,
                  url:   url
                });
              }
           }
           currentRoute = route;
          }
        });
      } while (currentRoute);
    });
  }

  ngOnInit(){ }

  toggleFavorite(){
    this.showFavOnly = !((Boolean)(JSON.parse(localStorage.getItem('showFavOnly'))));
    localStorage.setItem('showFavOnly',JSON.stringify(this.showFavOnly));
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app-breadcrumbs/app-breadcrumbs.component.ts